import { localStorageUtil } from '../../utils/local-storage.util';

export type PayedInternallyProps = Record<string, boolean>;

export const payedInternallyStore = localStorageUtil<PayedInternallyProps>('payedInternally');
